import React from 'react';
import 'twin.macro';
import ButtonGroup from 'components/Form/ButtonGroup';
import Button, { buttonRootStyle } from 'components/Buttons/Button';
import { MinusIcon, PlusIcon } from '@heroicons/react/16/solid';
import NumberInput from 'components/Form/NumberInput';

interface Props {
  onChange: (value: number) => void;
  value: number;
}

export function Margin(props: Props) {
  const { onChange, value } = props;
  return (
    <ButtonGroup tw="items-stretch">
      <Button
        icon={MinusIcon}
        tw="px-2"
        disabled={+value <= 0}
        onClick={() => onChange(+value - 1)}
      />
      <NumberInput
        css={[buttonRootStyle({})]}
        tw="rounded-none border-l border-r-0 w-[5rem] h-full"
        onChange={onChange}
        rightElement={<span tw="text-xs">mm</span>}
        value={+value}
        min={0}
      />
      <Button icon={PlusIcon} tw="px-2" onClick={() => onChange(+value + 1)} />
    </ButtonGroup>
  );
}
